<template>
  <li class="pd-Cart_Variant mb-1 mr-1">
    <a
      :class="buttonClasses"
      :title="property.value"
      @click.prevent="toggleActive"
      href="#"
      class="pd-Cart_VariantLink p-1 px-2 option-value"
    >
      <span class="text-break">{{ property.value }}</span>
    </a>
  </li>
</template>

<script>
import compareProperties from "../mixins/compareProperties";

export default {
  name: "VariantPickerPropertyButton",
  mixins: [compareProperties],
  props: {
    identifier: {
      type: String,
      default: "",
    },
    property: {
      required: true,
      type: Object,
    },
  },
  computed: {
    selectedProperties() {
      return this.$store.getters[`variantPicker${this.identifier}/selectedProperties`];
    },
    allProductVariants() {
      return this.$store.getters[`variantPicker${this.identifier}/allProductVariants`];
    },
    isActive() {
      return this.selectedProperties.some(selectedProperty =>
        this.compareProperties(selectedProperty, this.property)
      );
    },
    isLocked() {
      return !this.hasSelectedSibling && !this.selectedEmpty;
    },
    hasSelectedSibling() {
      const nestedPropertiesInCommonWithButtonProperty = this.allProductVariants
        .map(variant => variant.properties)
        .filter(variantProperties =>
          variantProperties.some(property => this.compareProperties(property, this.property))
        );

      const propertiesInCommonWithButtonProperty = Array.prototype.concat.apply(
        [],
        nestedPropertiesInCommonWithButtonProperty
      );

      const hasSelectedCommon = propertiesInCommonWithButtonProperty.some(storeProperty => {
        return this.selectedProperties
          .map(selectedProperty => this.compareProperties(selectedProperty, storeProperty))
          .some(condition => condition === true);
      });

      return hasSelectedCommon;
    },
    selectedEmpty() {
      return this.selectedProperties.length === 0;
    },
    buttonClasses() {
      return {
        "pd-Cart_VariantLink-inStock": true,
        "pd-Cart_VariantLink-selected": this.isActive,
        "pd-Cart_VariantLink-locked": this.isLocked,
      };
    },
  },
  methods: {
    toggleActive() {
      if (this.isLocked) {
        this.$store.dispatch(
          `variantPicker${this.identifier}/emptySelectedProperties`,
          this.property
        );
      }
      this.$store.dispatch(`variantPicker${this.identifier}/setSelectedProperties`, this.property);
    },
  },
};
</script>
